import requestState from "../../enums/RequestState"
export default {
    GET_REQUEST_STATE: (state) => (requestName) => {
        return state.requests[requestName] || requestState.IDLE;
    }
}